/*
 * Corrects client-side time using the server's clock.
 * Some students have incorrect system clocks (e.g. Arizona DST, misconfigured laptops),
 * which causes meeting Join buttons to appear at the wrong time.
 * The server embeds its timestamp in the page bootstrap data, and we compute
 * the offset to adjust Date.now() on the client. See #6786.
 */
let offset = 0;

export function initClockOffset(serverTime: number) {
  offset = serverTime - Date.now();
}

export function serverNow() {
  return new Date(Date.now() + offset);
}
